import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxDataGrid, {
      class: "salarii-grid",
      "data-source": _ctx.dsValoriParametriiSalarizare,
      "key-expr": "ID",
      "remote-operations": false,
      "show-row-lines": true,
      "hover-state-enabled": true,
      "show-borders": true,
      onCellPrepared: _ctx.onCellPrepared
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxFilterRow, { visible: true }),
        _createVNode(_component_DxPaging, { "page-size": 20 }),
        _createVNode(_component_DxLoadPanel, { enabled: true }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxColumn, {
          "data-field": "Cod",
          caption: "Cod"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Nume",
          caption: "Denumire"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Valoare",
          caption: "Valoare"
        })
      ]),
      _: 1
    }, 8, ["data-source", "onCellPrepared"])
  ]))
}